import React from "react";
import Jetfighter from "../../images/aktcorp/1-17.jpg";
import Buildtwo from "../../images/aktcorp/bahskyline.jpg";

export default function Sectiontwo() {
  return (
    <section className="w-full bg-[#0C2340] text-white">
      <div className="mx-auto px-4 py-0 md:py-0 lg:py-0">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 items-stretch">
          {/* Left Side - Jet Image and Text Content */}
          <div className="lg:col-span-4 flex flex-col space-y-4">
            {/* Jet Image */}
            <div className="overflow-hidden rounded-lg">
              <img
                src={Jetfighter}
                alt="Jet Fighter"
                className="w-full h-full object-cover transform scale-100 hover:scale-110 transition duration-300 ease-in-out"
              />
            </div>

            {/* Text Content */}
            <div className="bg-white text-[#0C2340] p-6 rounded-lg shadow-lg duration-300 ease-in-out flex-1 flex flex-col justify-center">
              <h2 className="text-2xl md:text-3xl font-bold mb-4">
                INNOVATIVE SOLUTIONS
              </h2>
              <p className="text-base md:text-lg text-justify leading-relaxed">
                At Arabian Karim Trading, we offer tailored industrial solutions to meet the unique needs of your
                projects. From high-quality tools and equipment to reliable solutions, our products and expert support
                ensure smooth and efficient operations. We also offer advanced silicones and specialty solutions,
                driving performance across industries such as agriculture, automotive, aerospace, electronics, energy,
                healthcare, personal care, consumer products, and construction. Our innovations are the foundation of
                progress and reliability for your business, ensuring smooth and efficient operations at all levels.
              </p>
            </div>
          </div>

          {/* Right Side - Building Image */}
          <div className="lg:col-span-8 flex items-center">
            <div className="overflow-hidden rounded-lg shadow-lg w-full h-full">
              <img
                src={Buildtwo}
                alt="Skyscrapers"
                className="w-full h-full object-cover transform scale-100 hover:scale-110 transition duration-300 ease-in-out"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
